import { Approval } from "./approval";

export class GroupApprovalData {
  /**
   * The group associated with the item.
   */
  group: string;

  /**
   * The array of tasks associated with the item.
   */
  tasks: Array<any> = [];

  /**
   * The array of approvals associated with the item.
   */
  approvals: Array<Approval> = [];

  /**
   * The array of selected rows.
   */
  selectedRows: Array<any> = [];

  /**
   * Indicates whether the item is selected.
   */
  isSelected: boolean;

  /**
   * Constructor
   * @param data
   */
  constructor(data?: any) {
    if (data) {
      this.group = data.group;
      this.tasks = data.tasks ? data.tasks : new Array<any>();
      this.approvals = data.approvals ? data.approvals : [new Approval()];
      this.selectedRows = data.selectedRows ? data.selectedRows : new Array<any>();
      this.isSelected = false;
    }
  }
}
